import { render } from "./JourneyDetailedInfo.vue?vue&type=template&id=7345a77d&scoped=true&lang=pug"
import script from "./JourneyDetailedInfo.vue?vue&type=script&lang=ts"
export * from "./JourneyDetailedInfo.vue?vue&type=script&lang=ts"

import "./JourneyDetailedInfo.vue?vue&type=style&index=0&id=7345a77d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7345a77d"

export default script